import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICountry } from "../../../Pages/Country/ICountry";

export const ListCountrySlice = createSlice({
  name: "ListCountrySlice",
  initialState: {} as IReduxState<ICountry[]>,
  reducers: {
    listCountry: (state) => {
      state.isLoading = true;
    },
    successlistCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistCountry, listCountry, successlistCountry } =
  ListCountrySlice.actions;

export default ListCountrySlice.reducer;
